import {
  PublicClientApplication,
  type Configuration,
  type RedirectRequest,
  type AccountInfo,
} from '@azure/msal-browser';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string;
const tenantId = '3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac';
export const scaniaAnalyticsApiScopes = [import.meta.env.VITE_SCANIA_ANALYTICS_API_SCOPE as string];

const defaultScopes = ['User.Read'];

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: `${globalThis.location.origin}/auth-redirect-bridge.html`,
    postLogoutRedirectUri: globalThis.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const loginRequest: RedirectRequest = {
  scopes: defaultScopes,
};

export const msalInstance = new PublicClientApplication(msalConfig);

const pickAccount = (accounts: AccountInfo[]): AccountInfo | null => {
  if (accounts.length === 0) {
    return null;
  }

  return accounts[0];
};

export async function setupAuthentication(): Promise<void> {
  await msalInstance.initialize();

  const redirectResult = await msalInstance.handleRedirectPromise();

  if (redirectResult?.account) {
    msalInstance.setActiveAccount(redirectResult.account);
    return;
  }

  const accounts = msalInstance.getAllAccounts();

  if (!msalInstance.getActiveAccount()) {
    const account = pickAccount(accounts);

    if (account) {
      msalInstance.setActiveAccount(account);
    }
  }
}
